import AmexPlatinumNightsVenuesRefresh from './AmexPlatinumNightsVenuesRefresh';

export default AmexPlatinumNightsVenuesRefresh;
